import { Box, SelectOption } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Selector from 'modules/core/components/Selector'
import { countries } from 'modules/core/lib/countryList'
import i18n from 'modules/core/lib/i18n'

import { dialCodeForCountry } from './dialCodes'

export interface Props {
  readOnly?: boolean
  label: string
  locale: string | null | undefined
  value: string | null | undefined
  onChange: (val: string) => void
  onClose?: () => void
  mandatory?: boolean
  error?: string
}
export const DialCodeSelector = ({
  mandatory,
  value,
  onChange,
  onClose,
  readOnly,
  label,
  locale,
  error,
}: Props) => {
  const phoneCodeWithPrefix = value?.startsWith('+') ? value : `+${value}`
  return (
    <Selector.Popover
      placeholder=""
      isDisabled={readOnly}
      label={label}
      blankLabel=""
      onChange={(val) => {
        val && onChange(String(val))
      }}
      value={[phoneCodeWithPrefix]}
      searchPlaceholder={i18n.t('common.search')}
      mandatory={mandatory}
      error={error}
      isMultiSelect={false}
      inputStyle="text"
      onToggle={(open) => {
        if (!open) onClose?.()
      }}
    >
      {getOptions({ countriesForOptions: countries(locale) })}
    </Selector.Popover>
  )
}

interface OptionProps {
  countriesForOptions: SelectOption[]
}

const getOptions = ({ countriesForOptions }: OptionProps) => {
  return countriesForOptions
    .map((country) => {
      const dialCode = dialCodeForCountry(country.value)
      return dialCode ? (
        <Selector.Option
          key={country.value}
          value={dialCode}
          label={dialCode}
          searchValue={country.label}
        >
          <Box>
            {country.label} ({dialCode})
          </Box>
        </Selector.Option>
      ) : null
    })
    .filter(Boolean)
}

export default observer(DialCodeSelector)
